"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderStickyPanelPriceOfferView = void 0;
const react_1 = __importDefault(require("react"));
const client_1 = __importDefault(require("react-dom/client"));
const NumberFormatter_1 = __importDefault(require("@react/web/Common/NumberFormatter/NumberFormatter"));
const OfferInquiryButtonView_1 = __importDefault(require("@react/web/SubscriptionOfferDetail/views/OfferInquiryButtonView"));
const StickyPanelPriceOfferView = ({ currentDisplayedPriceOffer, }) => react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("div", { className: "price-offer" },
        react_1.default.createElement("div", { className: "prices-container installment" },
            react_1.default.createElement("div", { className: "price-offer-price withoutVat" },
                react_1.default.createElement("span", { className: "price" }, NumberFormatter_1.default.formatPrice(currentDisplayedPriceOffer.monthlyPrice.withoutVat)),
                react_1.default.createElement("span", { className: "vat-info" }, "\u00A0bez DPH")),
            react_1.default.createElement("div", { className: "price-offer-price withVat" },
                react_1.default.createElement("span", { className: "price" }, NumberFormatter_1.default.formatPrice(currentDisplayedPriceOffer.monthlyPrice.withVat)),
                react_1.default.createElement("span", { className: "vat-info" }, "\u00A0s DPH")))),
    react_1.default.createElement("div", { className: "button-container" },
        react_1.default.createElement(OfferInquiryButtonView_1.default, { offer: currentDisplayedPriceOffer, gtmInquiryTypeEnum: "sticky-panel" })));
exports.default = StickyPanelPriceOfferView;
const renderStickyPanelPriceOfferView = (currentDisplayedPriceOffer) => {
    const stickyPanelPriceOfferElement = document.getElementById('sticky-panel-price-offer');
    if (stickyPanelPriceOfferElement !== null && currentDisplayedPriceOffer) {
        const root = client_1.default.createRoot(stickyPanelPriceOfferElement);
        root.render(react_1.default.createElement(StickyPanelPriceOfferView, { currentDisplayedPriceOffer: currentDisplayedPriceOffer }));
    }
};
exports.renderStickyPanelPriceOfferView = renderStickyPanelPriceOfferView;
